var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarContent = void 0;
var SnackbarContent_1 = __importDefault(require("./SnackbarContent"));
exports.SnackbarContent = SnackbarContent_1.default;
exports.default = SnackbarContent_1.default;
//# sourceMappingURL=index.js.map